module.exports = __webpack_public_path__ + "static/media/structFloat1.8f347b08.png";